import {z} from "zod";

const allowedTypes = ['application/pdf', 'image/*'];

const attachmentSchema = z.object({
    id: z.number(),
    name: z.string(),
    type: z.string(),
    dateTime: z.string(),
    size: z.number(),
});

type Attachment = z.infer<typeof attachmentSchema>;

export {attachmentSchema, type Attachment, allowedTypes};